import React, { useContext } from 'react';

import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import TypeStoreContext from 'context/TypeStoreContext';
import TitleWithRedirectDefault from './Interfaces/TitleWithRedirectDefault';
import WaitingForDataDynamicPage from 'components/WaitingForDataDynamicPage';
// import TitleWithRedirectGrocery from './Interfaces/TitleWithRedirectGrocery';

interface TitleWithRedirectProps {
	item: ItemDynamicPageInPhone;
}

//esse componente tem o mesmo layout em todos os tipos de loja, mas deixei essa função para demostrar como tem que ser a divisão por tipo (por que esse foi meu primeiro módulo que fiz o layout, depois posso apagar)
export default function TitleWithRedirect({ item }: TitleWithRedirectProps) {
	const { typeStore } = useContext(TypeStoreContext);

	function returnInterfaceByTypeStore() {
		switch (typeStore) {
			case 'default':
				return <TitleWithRedirectDefault item={item} />;

			case 'grocery':
				return <TitleWithRedirectDefault item={item} />;

			case 'fashion':
				return <TitleWithRedirectDefault item={item} />;

			default:
				return <TitleWithRedirectDefault item={item} />;
		}
	}

	return Object.keys(item.data).length === 0 ? (
		<WaitingForDataDynamicPage />
	) : (
		returnInterfaceByTypeStore()
	);
}
